// Copyright (c) 2021, DIALPAD INC., all rights reserved.

export const CX_QUESTION_TYPES = {
    NPS: 'nps',
    CSAT: 'csat',
    CES: 'ces',
};

export const CX_SCORE_TYPES = {
    VERY_DISSATISFIED: 'veryDissatisfied',
    DISSATISFIED: 'dissatisfied',
    SOMEWHAT_DISSATISFIED: 'somewhatDissatisfied',
    NEUTRAL: 'neutral',
    SOMEWHAT_SATISFIED: 'somewhatSatisfied',
    SATISFIED: 'satisfied',
    VERY_SATISFIED: 'verySatisfied',
};
